import moment from 'moment-jalaali'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { EyeIcon } from 'src/icons/icons'
import { TransactionItemType } from 'src/types'
import { TransactionOperation } from '../TransactionOperation'

export const TransactionRow = ({ refetch, ...record }: TransactionItemType & { refetch: Function }) => {

    const { t } = useTranslation()

    const { id, agent, amount, desc, file, status, created_at, method } = record

    const handleStatus = () => {
        if (status === 1) {
            return (
                <div className={`rounded-lg text-center py-2 text-green-200 bg-green-100 text-xs w-[80px] md:w-[86px]`}>
                    تایید شده
                </div>
            )
        } else if (status === 0) {
            return (
                <div className={`rounded-lg text-center py-2 text-primary-400 bg-primary-400/10 text-xs w-[80px] md:w-[86px]`}>
                    در انتظار
                </div>
            )
        } else if (status === 2) {
            return (
                <div className={`rounded-lg text-center py-2 text-red bg-red/10 text-xs w-[80px] md:w-[86px]`}>
                    عدم تایید
                </div>
            )
        }
    }


    const handleMethod = () => {
        switch (method) {
            case 'online': return `${t('PaymentGateway')}`;
            case 'offline': return t('SendPictureOfRecipe')
            case 'wallet': return t('Wallet')

            default: return '-'
        }
    }

    return (
        <tr key={id} className="bg-white border-b border-gray-400 [&>td]:text-center [&>td]:odd:bg-gray-50 [&>td]:hover:bg-gray-100">
            <td className="px-6  text-center">
                <div className={"text-gray-500 text-sm mt-1"}>
                    {id}
                </div>
            </td>

            <td className="px-6  text-center">
                <div className={"text-gray-500 text-sm mt-1 whitespace-nowrap"}>
                    {agent?.name ?? ''} {agent?.last_name}
                </div>
            </td>

            <td className="px-6  text-start text-primary-400 text-base font-semibold" title={`${amount.toLocaleString()} ${t('Toman')}`}>
                <div className={"mt-1"}>
                    {amount.toLocaleString()}
                </div>
            </td>
            <td className="  text-left ">
                <span className='line-clamp-2 text-ellipsis' title={desc}>
                    {desc ?? '-'}
                </span>
            </td>

            <td className="  text-left">
                <div className='flex flex-row justify-center items-center'>
                    {file ? <button className='bg-primary-300 rounded-lg text-white p-2 flex flex-row gap-1.5 items-center' onClick={() => window.open(`https://api.flysepehr.com/storage${file}`)}>{t('View')} <EyeIcon /></button> : '-'}
                </div>
            </td>

            <td className="  text-left">
                {moment(created_at).format('YYYY-MM-DD')}
            </td>

            <td colSpan={1} className=" justify-center text- end font-bold h-full">
                <div className={"text-gray-900 text-sm h-full font-bold flex flex-row justify-center items-center"}>
                    {handleMethod()}
                </div>

            </td>

            <td colSpan={1} className="px-3   justif y-center text -end">
                <div className={"text-gray-900 text-sm  flex flex-row justify-center"}>
                    {handleStatus()}
                </div>
            </td>
            <td className="  text-left">
                {status == 0 && method == 'offline' && <TransactionOperation id={id} onSuccessMutate={refetch} />}
            </td>
            {/* <td className="px-3  justify-center text-center">
            <div className={"text-gray-900 text-sm mt-1"}>
                {item.item_id}
            </div>
        </td>
        <td className="pl-12  text-left">
            <div className={"text-gray-900 text-sm mt-1"}>
                {item.transaction_id}
            </div>
        </td> */}
        </tr>
    )
}
